import { render, staticRenderFns } from "./PeopleJobsGrid.vue?vue&type=template&id=411de260&"
import script from "./PeopleJobsGrid.vue?vue&type=script&lang=js&"
export * from "./PeopleJobsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports